import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://ranok-fake-server.herokuapp.com/",
});

export default axiosInstance;
